import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';
import Button from '../Button';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import AuthSection from '../AuthSection';
import Form from '../Form';
import { FormInput } from '../FormInput/FormInput';

import styles from './Login.module.scss';

export function Login(): React.JSX.Element {
  const { login } = useAuth();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login(username, password);
    } catch (err: unknown) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError('Unexpected error');
      }
    } finally {
      setLoading(false);
    }
  };

  const leftContent = (
    <div className={styles.login}>
      <div className={styles.loginTitle}>
        <h1>Войти в Аккаунт</h1>
        <p>Давайте начнем, это бесплатно!</p>
      </div>
      <Form onSubmit={handleSubmit} className={styles.loginForm}>
        <FormInput
          label="Email"
          id="username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          required={true}
          disabled={loading}
          error={error}
        />
        <FormInput
          label="Пароль"
          id="password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required={true}
          disabled={loading}
          error={error}
        />
        <div className={styles.loginForgotPassword}>
          <Link to="#"> Забыл пароль</Link>
        </div>
        <Button className={styles.loginFormButton} type="submit" variant="default" disabled={loading}>
          {loading ? <LoadingSpinner size="sm" /> : 'Войти'}
        </Button>
        <div className={styles.loginSignUp}>
          У вас еще нет аккаунта?
          <Link to="/signup"> Зарегистрироваться</Link>
        </div>
      </Form>
    </div>
  );

  return <AuthSection>{leftContent}</AuthSection>;
}
